/* Keep the initial HTML video playing; never replace it after page load. */
(() => {
  function startVideo() {
    const video = document.querySelector('[data-koppa-about-video]');
    if (!video || video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    const button = document.querySelector('[data-about-video-toggle]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sync = () => {
      if (!button) return;
      button.hidden = false;
      button.textContent = video.paused ? 'Play video' : 'Pause video';
      button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
      button.setAttribute('aria-pressed', String(video.paused));
    };
    video.addEventListener('playing', sync);
    video.addEventListener('pause', sync);
    button?.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
    if (reduced) { video.autoplay = false; video.pause(); sync(); }
    else video.play().then(sync).catch(sync);
  }
  startVideo();
  document.addEventListener('shopify:section:load', startVideo);
})();
